import { css } from 'aphrodite/no-important';
import axios from 'axios';
import { Abstract, ModalWrapper, VideoPlayer } from 'components';
import { IGenericObject, ITrackSessionCategory, ITrackSessionData } from 'models';
import React, { FC, useEffect, useState } from 'react';
import { style } from './style';

interface Props {
  contentUrl: string;
  showCategories?: boolean;
}

export const TrackSessions: FC<Props> = ({ contentUrl, showCategories = true }) => {
  const [trackSessionsData, setTrackSessionsData] = useState([]);
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const [abstract, setAbstract] = useState<ITrackSessionData | null>(null);
  const styles = style({ isOipPath: true });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoContent, setVideoContent] = useState<IGenericObject | null>(null);

  // Fetch track session data for Oipath
  useEffect(() => {
    if (trackSessionsData.length === 0 && contentUrl) {
      (async () => {
        try {
          const response = await axios({ url: contentUrl });
          setTrackSessionsData(response.data);
        } catch (e) {
          console.error('CMS: Invalid track sessions data URL');
        }
      })();
    }
  }, [contentUrl, trackSessionsData]);

  const handleCategoryChange = (category: number) => {
    setActiveCategoryIndex(category);
  };

  /*const openAbstract = (trackSession: ITrackSessionData) => {
    setAbstract(trackSession);
    setIsModalOpen(true);
  };

  const openVideo = (videoOptions: IGenericObject) => {
    setVideoContent(videoOptions);
    setIsModalOpen(true);
  };*/

  const closeModal = () => {
    setAbstract(null);
    setVideoContent(null);
  };

  let trackSessionCount = 0;
  if (trackSessionsData.length > 0) {
    trackSessionCount = trackSessionsData.reduce((sum: number, category: ITrackSessionCategory) => {
      return (sum += category.category_data.length);
    }, 0);
  }

  if (trackSessionsData.length > 0) {
    const category: ITrackSessionCategory = showCategories
      ? trackSessionsData[activeCategoryIndex]
      : trackSessionsData[0];

    const trackSessions = category.category_data.map((track: ITrackSessionData, index) => {
      // const speakerNames = map(track.speakers, 'name');
      // const speakerCompanies = map(track.speakers, 'company');

      return null;
      /*<TrackSession
          key={index}
          sessionTitle={track.presentation_title}
          speakerNames={speakerNames}
          speakerCompanies={speakerCompanies}
          button1Text='Play'
          button2Text='See Abstract'
          onButton1Click={() => openVideo({ title: track.presentation_title, url: track.video })}
          onButton2Click={() => openAbstract(track)}
        />*/
    });

    return (
      <>
        {!!trackSessionCount && showCategories && <hr className={css(styles.hr)} style={{ display: 'block' }} />}

        {!!trackSessionCount && (
          <section className={css(styles.trackSessionsSection)}>
            <h2 className={css(styles.h2)}>Track Sessions</h2>
            {showCategories && (
              <div className={css(styles.trackSessionsCategories)}>
                {trackSessionsData.map((category: IGenericObject, index: number) => {
                  return (
                    <div
                      key={index}
                      className={css(
                        styles.trackSessionCategory,
                        index === activeCategoryIndex && styles.isActiveCategory
                      )}
                      onClick={() => handleCategoryChange(index)}>
                      <span dangerouslySetInnerHTML={{ __html: category.category_name }}></span>
                    </div>
                  );
                })}
              </div>
            )}
            <div className={css(styles.trackSessions)}>{trackSessions}</div>
          </section>
        )}
        {/* Abstract Modal */}

        <ModalWrapper
          isOpen={isModalOpen && (!!abstract || !!videoContent)}
          options={{ fillSmallerScreens: true }}
          onRequestClose={() => setIsModalOpen(false)}
          onAfterClose={() => closeModal()}>
          {abstract && (
            <Abstract
              title={abstract.presentation_title}
              abstract={abstract.presentation_abstract}
              speakerDetails={abstract.speakers}
              cmsData={{ speakers: 'Speakers', experience: 'Experience' }}></Abstract>
          )}

          {videoContent && (
            <VideoPlayer
              id='modal-video-iframe'
              src={videoContent.url}
              options={{
                aspectRatio: 16 / 9,
                title: videoContent.title,
              }}
              data={videoContent}
              autoplay={true}
            />
          )}
        </ModalWrapper>

        {/* Video Modal */}
      </>
    );
  } else {
    return null;
  }
};
